import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {broadcasts,broadcastRecent,broadcast,broadcastPush} = api

/**
 * 查找
 */
export async function findBroadcasts(params) {
    return request({url: broadcasts, method: 'get', data: params,})
}/**
 * 查找最新
 */
export async function findBroadcastRecent(params) {
    return request({url: broadcastRecent, method: 'get', data: params,})
}
/**
 * 查找详情
 */
export async function findBroadcast(params) {
    return request({url: broadcast, method: 'get', data: params,})
}/**
 * 推送
 */
export async function findBroadcastPush(params) {
    return request({url: broadcastPush, method: 'get', data: params,})
}
/**
 * 更新
 */
export async function updateBroadcast(params) {
    return request({url: broadcast, method: 'put', data: params,})
}
/**
 * 创建
 */
export async function createBroadcasts(params) {
    return request({url: broadcasts, method: 'post', data: params,})
}
/**
 *删除
 */
export async function deleteBroadcast(params) {
    return request({url: broadcast, method: 'delete', data: params,})
}






// WEBPACK FOOTER //
// ./src/services/dynamic.js